import metaApiClient from './meta-client';

export interface ChatfoodSyncRequest {
    token: string;
    user_ids: number[];
}

export interface ChatfoodSyncResult {
    matched: number;
    skipped: number;
    pages_updated: number;
    vars_saved: number;
    errors: { page_id: string; error: string }[];
}

export interface ChatfoodSyncAccepted {
    status: string;
    task_id: string;
}

export interface ChatfoodSyncStatus {
    status: string;
    result: ChatfoodSyncResult | null;
    error: string | null;
    matched?: number;
    skipped?: number;
    pages_updated?: number;
    vars_saved?: number;
}

export async function syncChatfoodPages(data: ChatfoodSyncRequest): Promise<ChatfoodSyncAccepted> {
    const response = await metaApiClient.post<ChatfoodSyncAccepted>('/admin/chatfood/sync', data);
    return response.data;
}

export async function getChatfoodSyncStatus(task_id: string): Promise<ChatfoodSyncStatus> {
    const response = await metaApiClient.get<ChatfoodSyncStatus>(`/admin/chatfood/sync/status/${task_id}`);
    return response.data;
}
